import { render, staticRenderFns } from "./SendMessageForm.vue?vue&type=template&id=25d6fbf2&web=true&"
import script from "./SendMessageForm.vue?vue&type=script&lang=js&"
export * from "./SendMessageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports